// client pages
import Home from "../pages/Client/Home/Home";
import Product from "../pages/Client/Product/Product";
import ProductDetail from "../pages/Client/Product/ProductDetail";
import Login from "../pages/Client/Login/Login";
import Register from "../pages/Client/Register/Register";
import Cart from "../pages/Client/Cart/Cart";
import Confirm from "../pages/Client/Confirm/Confirm";
import Profile from "../pages/Client/Profile/Profile";
import Search from "../pages/Client/Search/Search";
import ProductRating from "../pages/Client/Product/ProductRating";
import Wishlist from "../pages/Client/Wishlist/Wishlist";
// admin pages
import Admin from "../pages/Admin/Admin";
import AdminProduct from "../pages/Admin/AdminProduct";

const routes = [
    {
        path: "/",
        exact: true,
        component: Home
    },
    {
        path: "/home",
        exact: true,
        component: Home
    },
    {
        path: "/login",
        exact: false,
        component: Login
    },
    {
        path: "/register",
        exact: false,
        component: Register
    },
    {
        path: "/cart",
        exact: false,
        component: Cart
    },
    {
        path: "/confirm",
        exact: false,
        component: Confirm
    },
    {
        path: "/profile",
        exact: false,
        component: Profile
    },
    {
        path: "/search",
        exact: false,
        component: Search
    },
    {
        path: "/products/:category",
        exact: false,
        component: Product
    },
    {
        path: "/product-detail/:id",
        exact: false,
        component: ProductDetail
    },
    {
        path: "/product-rating/:orderId",
        exact: false,
        component: ProductRating
    },
    {
        path: "/wishlist",
        exact: false,
        component: Wishlist
    },
    {
        path: "/admin",
        exact: false,
        component: Admin
    },
    {
        path: "/admin-product",
        exact: false,
        component: AdminProduct
    },
]

export { routes }